import React, { useMemo, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import find from 'lodash/find'
import isNil from 'lodash/isNil'
import map from 'lodash/map'
import toLower from 'lodash/toLower'

import { Autocomplete } from '@material-ui/lab'

import { useDialog } from '@galo-monitor/dialog'
import { useT } from '@galo-monitor/i18n'
import useGaloMonitorApi from '@galo-monitor/services/hooks/useGaloMonitorApi'
import { AuthenticationActions } from '@galo-monitor/stores/authentication/duckAuthentication'
import { ContextActions } from '@galo-monitor/stores/context/duckContext'
import { PropertyActions } from '@galo-monitor/stores/property/duckProperty'
import { selectCurrentProperty } from '@galo-monitor/stores/property/selectorProperty'
import ErrorModal from '@galo-monitor/web-containers/modals/ErrorModal'

import { Input } from './theme'

function SelectProperty() {
  const t = useT()
  const dispatch = useDispatch()
  const { createDialog } = useDialog()

  const currentProperty = useSelector(selectCurrentProperty)

  const { data: properties } = useGaloMonitorApi('/farms/properties')

  const propertyOptions = useMemo(
    () =>
      map(
        properties, prop => ({
          value: String(prop.id),
          label: prop.name
        })
      ),
    [properties]
  )

  const handleChangeCurrentProperty = useCallback(
    (_, property) => {
      if (isNil(property)) {
        dispatch(PropertyActions.resetCurrentProperty())
      } else {
        const selectedProperty = find(properties, prop => String(prop.id) === property.value)
        dispatch(PropertyActions.setDefaultProperty(
          selectedProperty,
          () => {
            dispatch(ContextActions.initContextProperty())
            dispatch(PropertyActions.setCurrentProperty(selectedProperty))
            dispatch(AuthenticationActions.setUserDefaultProperty({
              id: selectedProperty.id,
              name: selectedProperty.name
            }))
          },
          () => createDialog({
            id: 'change-property-error-modal',
            Component: ErrorModal,
            props: {
              title: `${ t('could not {action} the {this}', {
                howMany: 1,
                gender: 'female',
                action: toLower(t('change')),
                this: toLower(t('property', { howMany: 1 }))
              })  }.`,
              message: t('try again contact support')
            }
          })
        ))
      }
    }
    ,
    [createDialog, dispatch, properties, t]
  )

  return (
    <div style={ { width: 250, marginRight: 5 } }>
      <Autocomplete
        name="select-property"
        options={ propertyOptions || [] }
        value={
          isNil(currentProperty)
            ? null
            : { value: String(currentProperty.id), label: currentProperty.name }
        }
        onChange={ handleChangeCurrentProperty }
        getOptionLabel={ (option) => option.label }
        getOptionSelected={ (option, selected) => option.value === selected.value }
        renderInput={ (params) => (
          <Input
            { ...params }
            label={ t('property', { howMany: 1 }) }
            margin="normal"
            placeholder={ t('select the property') }
          />
        ) }
        disableClearable
      />
    </div>
  )
}

export default SelectProperty
